import React from 'react';
import GeneralModal from 'components/SharedComponents/Modals/GeneralModal';
import { useTranslation } from 'react-i18next';
import { useFetchArchivedDashboards } from 'routes/AllDashboards/hooks/getDashboardsList';
import Loading from 'components/Loading';
import { Box } from '@mui/system';
import ArchivedDashboardCard from 'routes/AllDashboards/components/ArchivedDashboards/ArchivedDashboardCard';

type Props = {
    isOpen: boolean;
    onClose: () => void;
};

export default function ArchivedDashboardsModal({
    isOpen,
    onClose,
}: Props): React.ReactElement {
    const { t } = useTranslation();

    const { data: archivedDashboards = [], isLoading } =
        useFetchArchivedDashboards();

    const sortedArchivedDashboards = archivedDashboards.sort((a, b) =>
        a.title > b.title ? 1 : -1,
    );

    return (
        <GeneralModal
            isOpen={isOpen}
            onClose={onClose}
            title={t('dashboards.archivedDashboards')}
            width="md"
        >
            {isLoading ? (
                <Loading />
            ) : (
                <Box
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fill, 375px)',
                        justifyContent: 'space-evenly',
                        gap: 2,
                    }}
                    data-testid="archived-dashboards"
                >
                    {sortedArchivedDashboards.map((dashboard) => (
                        <Box key={dashboard.key}>
                            <ArchivedDashboardCard dashboard={dashboard} />
                        </Box>
                    ))}
                </Box>
            )}
        </GeneralModal>
    );
}
